<section class="container">
    <header>
        <div class="btn-group btn-breadcrumb">
            <a  class="btn btn-default" *ngFor="let item of header; index as i" (click)="onClick(i); removeFront(i)" >
                {{item}}
            </a>
        </div>
    </header>
  
    <div [style.display]="selected ? 'block' : 'none'" class="body-container">
      <!-- Content from the CdkStep is projected here -->
      <ng-container [ngTemplateOutlet]="selected.content"></ng-container>
    </div>
  
    <!--footer class="step-navigation-bar">
      <button class="nav-button" cdkStepperPrevious>&larr;</button>
      <button
        class="step"
        *ngFor="let step of steps; let i = index;"
        [ngClass]="{'active': selectedIndex === i}"
        (click)="onClick(i)"
      >
        Step {{i + 1}}
      </button>
      <button class="nav-button" cdkStepperNext>&rarr;</button>
    </footer-->
  </section>